export const isFirstOPtion = (currentOption) => {
    return currentOption.index === 0;
}

export const isLastOption = (currentOption, options) => {
    return currentOption.index === options.length - 1;
}

export const shiftOptionDown = (options, currentOption) => {
    return options.map((option) => {
        if (currentOption.index === option.index) {
            return { ...option, index: option.index + 1 }
        }
        if (currentOption.index + 1 === option.index) {
            return { ...option, index: option.index - 1 }
        }
        return option;
    });
}

export const shiftOptionUp = (options, currentOption) => {
    return options.map((option) => {
        if (currentOption.index === option.index) {
            return { ...option, index: option.index - 1 }
        }
        if (currentOption.index - 1 === option.index) {
            return { ...option, index: option.index + 1 }
        }
        return option;
    });
}


// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/messageSequencer/utils.js